import { useHits } from 'react-instantsearch'

import GridArchiveItem from '@/components/grid-archive/GridArchiveItem'
import PromoBlock from '@/components/promo-block/PromoBlock'

import type { Hit } from 'instantsearch.js'

type GridItemsProps = {
  isFiltered?: boolean
  sidebarContent?: React.ReactNode
}

export default function GridArchiveItems({
  isFiltered = false,
  sidebarContent = null,
}: GridItemsProps): JSX.Element {
  const { items } = useHits()

  if (!items?.length) {
    return <p>No results could be found</p>
  }

  const itemsToSplit = sidebarContent ? 4 : 8

  const firstGridRow = items.slice(0, itemsToSplit)
  const secondGridRow = items.slice(itemsToSplit)
  let firstGridRowClass = isFiltered
    ? 'col-span-4 grid-cols-4 m:grid-cols-2 s:grid-cols-1'
    : 'm-up:w-[calc(100%-400px)] m:w-full grid-cols-2 m:grid-cols-1'

  if (!sidebarContent) {
    firstGridRowClass = 'col-span-4 grid-cols-4 m:grid-cols-2 s:grid-cols-1'
  }

  return (
    <>
      <div className="flex items-start gap-l s:flex-col">
        <div
          className={`grid ${firstGridRowClass} w-full gap-l`}
          style={{ viewTransitionName: 'grid-transition' }}>
          {firstGridRow.map((item: Hit) => (
            <GridArchiveItem key={item.objectID} hit={item} size="l" />
          ))}
        </div>

        {!isFiltered && sidebarContent ? sidebarContent : null}
      </div>

      {!isFiltered ? (
        <div className="bg-theme py-0 text-fg breakout theme--gradient-light">
          <PromoBlock
            title="Sign up to receive the latest News & Insights"
            text="Get the latest news and updates from our team."
            link={{
              url: '/newsletter',
              title: 'Register',
              target: '_blank',
            }}
          />
        </div>
      ) : null}

      <div className="grid w-full grid-cols-4 items-start gap-l l:grid-cols-3 m:grid-cols-2 s:grid-cols-1">
        {secondGridRow?.length
          ? secondGridRow.map((item: Hit) => <GridArchiveItem key={item.objectID} hit={item} />)
          : null}
      </div>
    </>
  )
}
